<template>
    <div class="bgcolor" style="min-height: 100%;">
        <div class="paper_title_box">
            <div class="paper_title">{{testpaper_name}}</div>
        </div>
        <div class="container_warp">
            <div class="paper_left">
                <div class="time_box">
                    <div>考试时间</div>
                    <count-down class="t_down" v-if="startSecond!=''" :start="startSecond" end="0" v-on:endcallback="endFn" :autoshow='false' splitsymbol=":-:" :autostart="false" ref="countdown"></count-down>
                    <div class="t_down" :class="{'red':isStop}" v-else>{{h}} : {{m}} : {{s}}</div>
                    <div class="submit_btn cursor" @click="openSbtPop">交卷</div>
                </div>
                <div class="card_box">
                    <div class="card_title_box">答题卡</div>
                    <div class="mark_wrap">
                        <div class="mark_box">
                            <div class="mark_item" v-for="(val,key) in cardMark" :key="key">
                                <div class="mark_dot" :class="{'mark_dot_white':key==1}"></div>{{val}}
                            </div>
                        </div>
                    </div>
                    <div class="card_opt cursor" v-if="topic_data.length">
                        <template v-for="(val,key) in topic_data">
                            <div class="card_opt_title" v-if="key==0">{{val.genre.genre_name}}</div>
                            <template v-else-if="val.genre.genre_name!=topic_data[key-1].genre.genre_name">
                                <div class="card_opt_title">{{val.genre.genre_name}}</div>
                            </template>
                            <div class="card-btn-box">
                                <div @click="cardNav(key)" class="cu-btn" :class="{'card_active':((val.type==1||val.type==2||val.type==3)&&val.userAnswer!=='')||((val.type==5||val.type==4)&&val.userAnswer.trim()!=='')}">{{key+1}}</div>
                            </div>
                        </template>
                        
                    </div>
                </div>
            </div>
            <div class="paper_right">
                <div class="topic_main" :id="'h'+index" v-for="(subject,index) in topic_data" :key="index">
                    <div class="topic_title_box" :class="{'tpc_top':index!=0}" v-if="index==0||subject.genre.genre_name!==topic_data[index-1].genre.genre_name">{{subject.genre.genre_name}}</div>
                    <div class="topic_wrap_pl">
                        <div class="topic_item">
                            <div class="material_box tpc_top"  v-if="subject.material&&(index==0||!topic_data[index-1].material||topic_data[index-1].material.topic_stem!=subject.material.topic_stem)" v-html="strcharacterDiscode(subject.material.topic_stem)" @click="previewPicture($event)"></div>
                        </div>
                        <div class="topic_num_box" :class="{'topic_num_topline':index!=0&&(!subject.material&&subject.genre.genre_name==topic_data[index-1].genre.genre_name)}">
                            <div class="tnb_left">
                                <div class="tn_dot"></div>{{index+1}}/{{topic_data.length}}
                            </div>
                            <div class="tnb_right cursor">
                                <div class="tnb_right_w" v-if="!subject.isRecite" @click="showAnswer(subject,index)"><img class="look_img" src="../assets/answer.png" alt=""> 查看解析</div>
                                <div class="tnb_right_w" @click="openPopfk(subject)"><img class="fk_img" src="../assets/fk.png" alt=""> 错题反馈</div>
                                <div class="tnb_right_s" @click="FavorSubject(subject,index)"><img class="fk_img" :src="subject.userFavor?require('../assets/icon_collection2.png'):require('../assets/icon_collection1.png')" alt=""> 收藏</div>
                            </div>
                        </div>
                        <div class="txt_vh tpc_top" v-html="strcharacterDiscode(subject.title)" @click="previewPicture($event)"></div>
                        <!-- 简答题 -->
                        <template v-if="!subject.isRecite">
                            <div class="no_tpc" :class="{'topic_num_btmline':subject.material&&topic_data.length!=index+1}" v-if="subject.type==5">
                                <div class="area_warp">
                                    <textarea class="area_txt" :disabled="subject.disabledTxt" v-model="subject.userAnswer" placeholder="请在这里输入答案" maxlength="3000"></textarea>
                                    <div class="area_num">
                                        <div></div>
                                        <div>{{subject.userAnswer.length}}/3000</div>
                                    </div>
                                </div>
                                <div class="score_box">
                                    <div class="score_ipt_box">
                                        <input class="score_ipt" v-if="!subject.disabledScore" @click="tapInpt(index)" v-model="subject.userScore" :disabled="subject.disabledScore" @input="iptScore" type="number" placeholder="填写分数，不填默认为0">
                                        <div class="score_txt" v-else>自评分数：{{subject.userScore}}分</div>
                                    </div>
                                    <div class="score_btn_wrap" v-if="!subject.disabledScore">
                                        <div class="score_btn" :class="{'opt5':subject.disabledScore}" @click="submitScore(index,subject)">评分</div>
                                    </div>
                                </div>
                                <div class="score_hit" v-if="!subject.disabledScore">最大分值{{parseFloat(subject.score)}}分，点击按钮提交自评分，否则视为0分</div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="myAnwer_box" v-if="subject.type==5">
                                <div class="anwer_box_left" :class="{'r_txt':subject.disabledScore&&subject.userScore==subject.score,'w_txt':subject.disabledScore&&subject.userScore<subject.score}">我的自评：{{!subject.disabledScore?'未进行自我评分':subject.userScore+'分'}}</div>
                                <div class="anwer_box_left myAnwer_box">
                                    <img class="statu_img" :src="!subject.disabledScore?require('../assets/statu2.png'):subject.score==subject.userScore?require('../assets/statu1.png'):require('../assets/statu3.png')" alt="">
                                    <span :class="{'r_txt':subject.disabledScore&&subject.userScore==subject.score,'w_txt':subject.disabledScore&&subject.userScore<subject.score}">我的作答：</span>
                                </div>
                                <div class="myAnwer_txt">{{subject.userAnswer==''?'未作答':subject.userAnswer}}</div>
                            </div>
                        </template>
                        <!-- 简单题 -->
                        <!-- 单选、判断 -->
                        <template v-if="!subject.isRecite">
                            <div class="opt_group_box" :class="{'topic_num_btmline':subject.material&&topic_data.length!=index+1}" v-if="subject.type==1||subject.type==2">
                                <label :for="option.id" v-for="(option,idxs) in subject.optionList" :key="idxs" @click.stop.prevent="RadioboxChange(option,index)">
                                    <input v-show="false" type="radio" :id="option.id" :name="option.id">
                                    <div class="radio_opt_wrap">
                                        <div class="radio_opt_box" :class="{'opt_active':subject.userAnswer===option.id}">{{option.text}}</div>
                                        <div class="txt_vh" v-html="strcharacterDiscode(option.content)" @click="previewPicture($event)"></div>
                                    </div>
                                </label>
                            </div>
                        </template>
                        <template v-else>
                            <div class="opt_group_box" v-if="subject.type==1||subject.type==2">
                                <div class="radio_opt_wrap" v-for="(option,idxs) in subject.optionList" :key="idxs">
                                    <div class="radio_opt_box" :class="{'only_r':idxs===parseInt(subject.answer),'w_active':subject.item_status==='wrong'&&idxs===parseInt(subject.userAnswer),'r_active':subject.item_status==='right'&&idxs===parseInt(subject.userAnswer)}">{{option.text}}</div>
                                    <div class="txt_vh" v-html="strcharacterDiscode(option.content)" @click="previewPicture($event)"></div>
                                </div>
                            </div>
                        </template>
                        <!-- 单选、判断 -->
                        <!-- 多选 -->
                        <template v-if="!subject.isRecite">
                            <div class="opt_group_box" :class="{'topic_num_btmline':subject.material&&topic_data.length!=index+1}" v-if="subject.type==3">
                                <label :for="option.id" v-for="(option,idxs) in subject.optionList" :key="idxs" @click="CheckboxChange(index,option)">
                                    <input v-show="false" type="checkbox" :ref="'check'+index" :id="option.id">
                                    <div class="radio_opt_wrap">
                                        <div class="radio_opt_box" :class="{'opt_active':subject.userAnswer.indexOf(option.id) > -1}">{{option.text}}</div>
                                        <div class="txt_vh" v-html="strcharacterDiscode(option.content)" @click="previewPicture($event)"></div>
                                    </div>
                                </label>
                            </div>
                        </template>
                        <template v-else>
                            <div class="opt_group_box" v-if="subject.type==3">
                                <div class="radio_opt_wrap" v-for="(option,idxs) in subject.optionList" :key="idxs">
                                    <template v-if="subject.item_status === null || subject.item_status === 'none'">
                                        <div class="radio_opt_box" :class="{'only_r':subject.answer[idxs]===idxs.toString()}">{{option.text}}</div>
                                    </template>
                                    <template v-else-if="subject.item_status === 'right'">
                                        <div class="radio_opt_box" :class="{'r_active':subject.uAnswer[idxs]===idxs.toString()}">{{option.text}}</div>
                                    </template>
                                    <template v-else-if="subject.item_status === 'wrong'">
                                        <div class="radio_opt_box only_r" v-if="subject.uAnswer[idxs]==undefined && subject.answer[idxs]!=undefined">{{option.text}}</div>
                                        <div class="radio_opt_box w_active" v-else-if="subject.uAnswer[idxs]!=undefined && subject.answer[idxs]==undefined">{{option.text}}</div>
                                        <div class="radio_opt_box r_active" v-else-if="subject.uAnswer[idxs]!=undefined && subject.answer[idxs]!=undefined">{{option.text}}</div>
                                        <div class="radio_opt_box" v-else>{{option.text}}</div>
                                    </template>
                                    <div class="txt_vh" v-html="strcharacterDiscode(option.content)" @click="previewPicture($event)"></div>
                                </div>
                            </div>
                        </template>
                        <!-- 多选 -->

                        <!-- 解析 -->
                        <template v-if="subject.isRecite">
                            <div class="anwer_box" v-if="subject.type==1||subject.type==2||subject.type==3">
                                <div class="anwer_box_left">
                                    <img class="statu_img" :src="subject.item_status === null?require('../assets/statu2.png'):subject.item_status === 'right'?require('../assets/statu1.png'):require('../assets/statu3.png')" alt="">
                                    <template v-if="subject.type==1||subject.type==2">
                                        <span :class="{'n_txt':subject.item_status === null,'r_txt':subject.item_status === 'right','w_txt':subject.item_status === 'wrong'}">我的作答：{{subject.item_status === null?'未作答':strOption[subject.userAnswer]}}</span>
                                    </template>
                                    <template v-else-if="subject.type==3">
                                        <span :class="{'n_txt':subject.item_status === null,'r_txt':subject.item_status === 'right','w_txt':subject.item_status === 'wrong'}">我的作答：</span>
                                        <span v-if="subject.item_status === null" class="n_txt">未作答</span>
                                        <span v-else :class="{'r_txt':subject.item_status === 'right','w_txt':subject.item_status === 'wrong'}" v-for="(s,k) in subject.userAnswer" :key="k">{{strOption[s]}}</span>
                                    </template>
                                </div>
                                <template v-if="subject.type==1||subject.type==2">
                                    <div class="anwer_box_right">正确答案：{{strOption[subject.answer]}}</div>
                                </template>
                                <template v-else-if="subject.type==3">
                                    <div class="anwer_box_right"><span>正确答案：</span><span v-for="(v,i) in subject.answer" :key="i">{{strOption[v]}}</span></div>
                                </template>
                            </div>
                            <div class="j_anwer_box" v-if="subject.type==4||subject.type==5">
                                <div>答案</div>
                                <div class="j_anwer_content j_anwer_content_pt" v-if="subject.answer==''">暂无答案</div>
                                <div class="j_anwer_content" v-else v-html="strcharacterDiscode(subject.answer)" @click="previewPicture($event)"></div>
                            </div>
                            <div class="j_anwer_box analy_btm_padd" :class="{'topic_num_btmline':subject.material}">
                                <div>解析</div>
                                <div class="j_anwer_content j_anwer_content_pt" v-if="subject.explain==''">暂无解析</div>
                                <div class="j_anwer_content" v-html="strcharacterDiscode(subject.explain)" @click="previewPicture($event)"></div>
                            </div>
                        </template>
                        <!-- 解析 -->
                    </div>
                    
                </div>
                <div class="footer_block"></div>
            </div>
        </div>
                
        <!-- 纠错弹框 -->
        <el-dialog title="错题反馈" class="popup" :visible.sync="dialogFormVisible" center>
            <div class="wrong_pop_title ">
                <div class="tn_dot"></div><div>错误类型（可多选）</div>
            </div>
            <div class="worng_nav_wrap">
                <div class="worng_nav cursor" v-for="(val,key) in wrongFk" :key="key">
                    <div class="worng_nav_sub" :class="{'popw_active':val.checked}" @click="FKselect(key)">{{val.name}}</div>
                </div>
            </div>
            <div class="wrong_pop_title w_mt">
                <div class="tn_dot"></div><div>错误详情</div>
            </div>
            <div class="textarea_wrap">
                <textarea v-model="textarea" maxlength="100"></textarea>
            </div>
            <div class="wrong_pop_btn cursor" :class="{'ogrey':selectchick.length==0}" @click="worngSubmit">提交</div>
        </el-dialog>
               
        <!-- 自动交卷 -->
        <div class="shade" v-if="popupSubimt">
            <div class="pop_submit">
                <div class="pop_submit_title">做题时间已到，系统自动交卷</div>
                <div class="pop_submit_btn" @click="closeSubmit">确定</div>
                <i class="el-icon-close pop_i_close" @click="closeSubmit"></i>
            </div>
        </div>
        <!-- 手动交卷弹框 -->
        <div class="shade" v-if="isSubmit">
            <div class="pop_submit">
                <div class="pop_submit_title">{{isBtnTxt?'是否继续交卷？':'你还有试题尚未完成，是否交卷？'}}</div>
                <div class="pop_btm_btn">
                    <div class="p_left_btn cursor" @click="closeSbtPop">{{isBtnTxt?'检查':'继续做题'}}</div>
                    <div class="p_right_btn cursor" @click="SbtPop">交卷</div>
                </div>
                <i class="el-icon-close pop_i_close" @click="closeSbtPop"></i>
            </div>
        </div>

        <!-- 二维码弹框 -->
        <div class="shade" v-if="isCode">
            <div class="pop_submit code_pop_box">
                <div class="pop_code_title">请添加客服老师领取现金红包</div>
                <img v-if="codeData" class="code_icon" :src="codeData.qrcode" alt="">
                <i class="el-icon-close pop_code_close" @click="closeCodePop"></i>
            </div>
        </div>
        
        <img v-if="isScroll" class="scllotop_img" src="../assets/scllotop.png" alt="" @click="scllotop">
        <picture-preview :visible.sync="picturePreview.visible" :closeOnClickModal="picturePreview.closeOnClickModal" :src="picturePreview.src" />
    </div>
</template>

<script>
    import store from '../store'
    import CountDown from 'dircountdown'
    import SingleChoice from '@/components/SingleChoice'
    import MultipleChoice from '@/components/MultipleChoice'
    import TrueFalse from '@/components/TrueFalse'
    import Subjective from '@/components/Subjective'
    import strcharacterDiscode from '@/js/strcharacterDiscode'
    import PicturePreview from '@/components/PicturePreview/PicturePreview.vue'
    
    var flag=false;

    export default {
        name: 'DoTopic',
        components: {
            SingleChoice,
            MultipleChoice,
            TrueFalse,
            Subjective,
            CountDown,
            PicturePreview,
        },
        data () {
            return {
                testpaper_name: '',
                topic_data: [],
                all_data: null,
                material_data: [],
                submitData: {},
                testTitle: '',
                // startSecond: '7200',
                startSecond: '',
                form: {
                    input:'',
                    checkboxGroup: []
                },
                dialogFormVisible: false,
                formLabelWidth: '120px',
                tiGanTops: [],
                cardMark: ['已做','未做'],
                h: '00',//时
				m: '00',//分
				s: '00',//秒
				allTime: 0,//86397
				timeId: null,
                popupSubimt: false,
                isSubmit: false,
                wrongFk: [],
                activeWId: null,
                textarea: '',
                isScroll: false,
                timer: null,
                isUpdata: true,
                isBtnTxt: false,
                picturePreview: {
                    visible: false,
                    src: '',
                    closeOnClickModal: true
                },
                isStop: false,
                selectchick: [],
                tpIndex: 0,
                strOption: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
                isCode: false,
                codeData: null,
                startTime: '',
				endTime: ''
            }
        },
        methods: {
            closeCodePop() {
                this.isCode=false
            },
            getConfigure() {
                this.$http.get("/api/v2/wrong_topic/getConfigure",{
                     headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                    }
                })
                .then(res=>{
                    if(res.data.code===1){
                        this.codeData=res.data.data
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                })
            },
            showAnswer(e,i) {
                if(e.type==1||e.type==2){
                    console.log(e,789)
					if(e.userAnswer===''){
                        this.$set(this.topic_data[i], "item_status", null);
					}else if(e.userAnswer===parseInt(e.answer)){
                        this.$set(this.topic_data[i], "item_status", 'right');
					}else if(e.userAnswer!==''&&e.userAnswer!==parseInt(e.answer)){
                        this.$set(this.topic_data[i], "item_status", 'wrong');
					}
				}
				if(e.type==3){
					
					if(e.userAnswer==''){
						this.$set(this.topic_data[i], "item_status", null);
					}else if(e.userAnswer.sort().toString()===e.answer){
						this.$set(this.topic_data[i], "item_status", 'right');
					}else{
						this.$set(this.topic_data[i], "item_status", 'wrong');
					}
					this.topic_data[i].answer=this.reAnswerData(e.answer.split(","))
					this.$set(this.topic_data[i], "uAnswer", this.reAnswerData(e.userAnswer));
				}
                this.topic_data[i].isRecite=true
            },
            submitScore(i,v) {
                if(!this.topic_data[i].disabledScore){
                    if((this.topic_data[i].userScore<parseFloat(v.score)||this.topic_data[i].userScore==parseFloat(v.score))&&this.topic_data[i].userAnswer.trim()!=''){
                        if(this.topic_data[i].userScore==''){
                            this.topic_data[i].userScore=0
                        }
                        this.topic_data[i].disabledScore=true
                        this.topic_data[i].disabledTxt=true
                    }else{
                        if(this.topic_data[i].userScore>parseFloat(v.score)){
                            this.$message.error(`评分不能超过${parseFloat(v.score)}`);
                        }else if(this.topic_data[i].userAnswer.trim()==''){
                            this.$message.error(`请输入答案后再评分`)
                        }
                    }
                }
            },
            tapInpt(e) {
                console.log(e,'index')
                this.tpIndex=e
            },
            reAnswerData: function(arr) {
				var aData=[];
				
					for(var i=0;i<arr.length;i++){
						aData[arr[i]]=arr[i]
					}
				
				return aData;
			},
            iptScore(e) {
                var v=this.topic_data[this.tpIndex].userScore,d
				var index=v.indexOf('.')
				if(v!==''){
					if(index==-1){
						if(v>0){
							d=parseInt(v)
						}else{
							if(parseInt(v)==0&&v.length>1){
								d=0
							}else{
								d=parseInt(v)
							}
						}
					}else{
						if(v==0||v<0){
							d=parseFloat(0)
						}else{
							if(index==0){
								d=parseFloat("0"+v.toString().slice(0,index+2))
							}else{
								d=parseFloat(v.toString().slice(0,index+2))
							}
						}
					}
                    this.topic_data[this.tpIndex].userScore=d
				}
            },
            previewPicture(e) {
                // console.log(e.target.src,666)
                if(e.target.src){
                    this.picturePreview.src = e.target.src;
                    this.picturePreview.visible = true;
                }
            },
            getdata() {
               
                this.$http.get('/api/v2/testpaper/getTestpaperWithTopic',{
                    headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                    },
                    params:{
                       testpaper_id: this.$route.query.id,
                       v: 2
                    }
                }).then((res) => {
                    if(res.data.code===1){
                        console.log(res,559)
                        
                        this.all_data=res.data.data
                        this.topic_data=res.data.data.topics;
                        for (var i = 0; i < this.topic_data.length; i++) {
							if(this.topic_data[i].type==4||this.topic_data[i].type==5){
                                this.$set(this.topic_data[i], "userScore", '');
                                this.$set(this.topic_data[i], "disabledScore", false);
                                this.$set(this.topic_data[i], "disabledTxt", false);
                            }
                            this.$set(this.topic_data[i], "isRecite", false);
                        }
                        

                        if(!this.topic_data.length){
                            this.$message.error("暂无题目,请去做其他试卷");
                        }

                        var local=localStorage.getItem("tpTimeData") ? JSON.parse(localStorage.getItem("tpTimeData")): null;
                        if(res.data.data.testpaper_limited_time>0){
                            // localStorage.setItem("area_code", 440100);
                            // localStorage.removeItem("tpTimeData")
                            
                            if(local&&local.testpaper_id==res.data.data.testpaper_id){
                                console.log(1,"time")
                                this.startSecond=(local.endTime-res.data.data.system_time>0?local.endTime-res.data.data.system_time:1).toString()
                            }else{
                                
                                console.log(2,"time")
                                var tptd={
                                    testpaper_id: res.data.data.testpaper_id
                                },
                                 et=res.data.data.system_time+(res.data.data.testpaper_limited_time*60);
                                tptd.endTime=et
                                localStorage.setItem("tpTimeData", JSON.stringify(tptd));
                                this.startSecond=(res.data.data.testpaper_limited_time*60).toString();
                            }
                            
                        }else{
                            console.log(3,"time")
                            if(local&&local.testpaper_id==res.data.data.testpaper_id&&localStorage.getItem("tpTimeData").allTime){
                                this.allTime=local.allTime
                            }
                        }
                        this.clock()
			            this.startTimer()
                        this.$nextTick(() => {
                            if(res.data.data.testpaper_limited_time>0){
                                this.$refs.countdown.countTime();
                            }
                        })
                        this.startTime=Date.parse(new Date())
                        // this.material_data=res.data.data.material_data;
                        // this.$nextTick(() => {
                        //     this.tiGanTops=this.tiGanTop();
                            
                        // })
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                        var that=this;
                        if(res.data.msg=='暂无题目'){ //没有试题返回上一层页面
                            window.setTimeout(function(){
                                that.$router.go(-1);
                            },1000)
                        }
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },
            //单选类型
            RadioboxChange(e,i) {
                this.topic_data[i].userAnswer=e.id
            },
            //多选类型
            CheckboxChange(e,d) {
                this.$refs['check'+e][d.id].checked=!this.$refs['check'+e][d.id].checked
               
                var arr= this.$refs['check'+e],a=[]
                for(var i=0;i<arr.length;i++){
                    if(arr[i].checked){
                        a.push(i)
                    }
                    // else{
                    //    console.log(a.indexOf(i),990)
                    //    a.indexOf(i)>-1?a.splice(i,1):''
                    // }
                }
                a.length==0?this.topic_data[e].userAnswer='':this.topic_data[e].userAnswer=a
               
            },
            //收藏
            FavorSubject(e,i) {
                if(e.userFavor){
                    this.uncollect(e.id,i)
                }else{
                    this.collect(e.id,i)
                }
            },
            collect(id,i) {
                this.$http.post("/api/v2/question/collect",{
                    collection_testpaper_topic_id: id
                },
                {
                    headers: {
                        token:
                            localStorage.getItem("token") !== null
                            ? localStorage.getItem("token")
                            : ""
                    }
                }).then(res=>{
                    if(res.data.code===1){
                        this.topic_data[i].userFavor=true
                        this.$message("收藏成功")
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                })
            },
            uncollect(id,i) {
                this.$http.post("/api/v2/question/unCollect",{
                    collection_testpaper_topic_id: id
                },
                {
                    headers: {
                        token:
                            localStorage.getItem("token") !== null
                            ? localStorage.getItem("token")
                            : ""
                    }
                }).then(res=>{
                    if(res.data.code===1){
                        this.topic_data[i].userFavor=false
                        this.$message("取消收藏")
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                })
            },
            clock() { //计时器
				let seconds = this.allTime
				let [day, hour, minute, second] = [0, 0, 0, 0]
				
				hour = Math.floor(seconds / (60 * 60)) - (day * 24)
				minute = Math.floor(seconds / 60) - (day * 24 * 60) - (hour * 60)
				second = Math.floor(seconds) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60)
				if (hour < 10) {
					hour = '0' + hour
				}
				if (minute < 10) {
					minute = '0' + minute
				}
				if (second < 10) {
					second = '0' + second
				}
				this.h = hour
				this.m = minute
				this.s = second
               
                if(parseInt(hour)>=24||(parseInt(hour)==23&&parseInt(minute)==59&&parseInt(second)==59)){
                    clearInterval(this.timeId)
                    this.isStop=true
                }
			},
			//开始计时
			startTimer() {
				this.timeId = setInterval(() => {
					this.allTime++
					this.clock()
				}, 1000)
			},
            worngSubmit() {
                var type = [];
                for(var i=0;i<this.wrongFk.length;i++){
					if(this.wrongFk[i].checked){
						type.push(this.wrongFk[i].id)
					}
				}
                if(type.length == 0){
                    this.$message.error('请选择错误类型')
                    return false;
                }
                var data = {
					wrong_topic_cate_id: type.join(),
					topic_id: this.activeWId,
					testpaper_id: this.all_data.testpaper_id
				};
				this.textarea!=''? data.description=this.textarea:'';
                this.subtimApi(data)
            },
            subtimApi(data) {
                this.$http.post("/api/v2/wrong_topic/addWrongTopic",data,{
                    headers: {
                        token:
                            localStorage.getItem("token") !== null
                            ? localStorage.getItem("token")
                            : ""
                        // 'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(res=>{
                    if(res.data.code===1){
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        })
                        this.dialogFormVisible = false
                        if(this.codeData&&this.codeData.status==1){
                            this.isCode=true
                        }
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
            },
            openPopfk(e) {
                // console.log(e,551)
                this.activeWId=e.topic_id
                this.textarea= ''
                this.wrongFk.forEach((e,i)=>{
                    e.checked=false
                })
                this.dialogFormVisible = true
            },
            FKselect(i) {
                this.wrongFk[i].checked=!this.wrongFk[i].checked
                var selectchick=[]
                for(var i=0;i<this.wrongFk.length;i++){
					if(this.wrongFk[i].checked){
						selectchick.push(this.wrongFk[i].id)
					}
				}
                this.selectchick=selectchick            
            },
            scllotop() {
                let returnEle = document.querySelector(".paper_title_box");
                if(!!returnEle){
                    document.documentElement.scrollTop = returnEle.offsetTop
                }
            },
            getCategory() {
                this.$http.get("/api/v2//wrong_topic/getCategory").then(res=>{
                    if(res.data.code===1){
                        // console.log(res,888)
                        var w=res.data.data.lists
                        w.forEach((e,i)=>{
                            e.checked=false
                        })
                        this.wrongFk=w
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                })
            },
            selectTitle(title) {
                this.testTitle = title;
                return 'aaaa'
            },
            getSingleData(index) {
                
                this.submitData[index[1]]=index[0]
                
            },
            getMultipleData(itemMultipleData) {
                this.submitData[itemMultipleData[1]]=itemMultipleData[0]
                
            },
            getTruefalseData(index) {
                this.submitData[index[1]]=index[0]
                
            },
            getSubjectiveData(subjctData) {
                this.submitData[subjctData[1]]=subjctData[0]  
            },
            cardNav(id) {
                // var allEle=document.querySelectorAll(".el-card__header");
                // let returnEle = document.querySelector("#option"+id);
                // !!returnEle && returnEle.scrollIntoView(true);


                // if(!!returnEle){
                //     document.documentElement.scrollTop = (returnEle.offsetTop - allEle[0].clientHeight)
                // }

                let returnEle = document.querySelector("#h"+id);
                if(!!returnEle){
                    document.documentElement.scrollTop = returnEle.offsetTop
                }
            },
            closeSbtPop() {
                this.isSubmit=false
            },
            openSbtPop() {
                this.isBtnTxt=true
                for(var i=0;i<this.topic_data.length;i++){
                    // if(this.topic_data[i].type== 1||this.topic_data[i].type== 2||this.topic_data[i].type==3){
                        if(((this.topic_data[i].type== 1||this.topic_data[i].type== 2||this.topic_data[i].type==3)&&this.topic_data[i].userAnswer ==='')||((this.topic_data[i].type== 4||this.topic_data[i].type== 5)&&!this.topic_data[i].disabledScore)) {
                            this.isBtnTxt=false
                            break;
                        }
                        
                    // }
                }
                this.isSubmit= true
            },
            SbtPop() {
                this.onSubmit()
                this.isSubmit=false
            },
            //自动提交
            closeSubmit() {
                this.onSubmit()
                this.popupSubimt=false
            },
            // 提交
            onSubmit() {
                this.isUpdata=false
                var data = {},do_time,obj ={};
                this.topic_data.forEach((item,i)=>{
                    if (item.userAnswer !== ''&& (item.type==1||item.type==2||item.type==3)) {
                        data[item.id] = {'answer':item.userAnswer}
                    }
                    if((item.type==5||item.type==4)&&item.disabledScore){
                        data[item.id] = {
                            score: item.userScore,
                            answer: item.userAnswer
                        }
                    }
                })
                
                if(this.startSecond!='' && this.allTime>Number(this.startSecond)){
					do_time=Number(this.startSecond)
				}else{
					do_time=this.allTime
				}

                obj.testpaper_id=this.$route.query.id
                obj.do_time=do_time
                obj.data=data

                this.$http.post("/api/v2/testpaper/markTestpaper",obj,
                // {
                //     data:this.submitData,
                //     testpaper_id:this.$route.query.id
                //   },
                  {
                      headers:{
                          'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                      }
                  })
                .then(res => {
                    
                    if(res.data.code===1){
                        // this.$router.push({name: 'analysis',params: {testpaper_id:res.data.data.testpaper_id,result_id:res.data.data.result_id}})
                        localStorage.removeItem("tpTimeData")
                        var data=res.data.data;
                        data.testpaper_name=this.testpaper_name;
                        this.$router.push({path: '/grade',query: data})
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                        
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
                .catch(errors => {
                    console.log(errors);
                }); 
                // console.log(this.$refs.headerChild.radio2) 
            },
            // 纠错反馈提交
            wrongSubmit() {
                this.dialogFormVisible = false;
                // console.log(this.form.checkboxGroup)
            },
            endFn(){
                // alert("时间到!");
                // this.onSubmit()
                this.popupSubimt=true
            },
            //实时统计做题
            updatePaper(obj) {
                this.$http.post("/api/v2/testpaper/updatePaperRealSubject",obj,{
                    headers:{
                      'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                    }
                }).then(res=>{
                    console.log(res,8890)
                })
            },
            //统计学习时长
            incrUserStudyTime(obj) {
                this.$http.post("/api/v2/member/incrUserStudyTime",obj,{
                    headers:{
                      'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                    }
                }).then(res=>{
                    console.log(res,"统计学习时长")
                })
            },
            startCount(){
                // this.$refs.countdown.countTime();
            },
            mark(key) {
                flag=!flag;
                flag ? this.$refs.mark[key].className="activebj" : this.$refs.mark[key].className="bj";
                flag ? this.$refs.iMark[key].style.display="block" : this.$refs.iMark[key].style.display="none";
                
            },
            tiGanTop() {
                var tiGan=[];
                document.querySelectorAll(".card_tit").forEach(item => {
                    tiGan.push(item.offsetTop);
                })
                return tiGan;
            },
            handleScroll() {
                clearTimeout(this.timer)
                this.isScroll=true
                this.timer=setTimeout(()=>{
                    this.isScroll=false
                },2000)

                var tiGan=this.tiGanTops;
                var allEle=document.querySelectorAll(".el-card__header");
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                for(var i=0;i<tiGan.length;i++){
                    // 顺滚标题置顶
                    if(scrollTop>tiGan[i] && scrollTop<tiGan[i+1]){
                        allEle[i].style.position='fixed';
                        allEle[i].style.top=0;
                        allEle[i].style.zIndex=2;
                        allEle[i].style.background='#ffffff';
                        allEle[i].style.width=allEle[i].parentNode.offsetWidth+'px';
                    }else{
                        allEle[i].style='';
                    }

                    if(scrollTop>tiGan[tiGan.length-1]){
                        allEle[tiGan.length-1].style.position='fixed';
                        allEle[tiGan.length-1].style.top=0;
                        allEle[tiGan.length-1].style.zIndex=2;
                        allEle[tiGan.length-1].style.background='#ffffff';
                        allEle[tiGan.length-1].style.width=allEle[i].parentNode.offsetWidth+'px';
                    }else{
                        allEle[tiGan.length-1].style='';
                    }

                    // 回滚标题置顶
                    if(scrollTop<tiGan[tiGan.length-1]&&scrollTop>tiGan[tiGan.length-2]){
                        allEle[tiGan.length-2].style.position='fixed';
                        allEle[tiGan.length-2].style.top=0;
                        allEle[tiGan.length-2].style.zIndex=2;
                        allEle[tiGan.length-2].style.background='#ffffff';
                        allEle[tiGan.length-2].style.width=allEle[i].parentNode.offsetWidth+'px';
                    }else if(scrollTop<tiGan[i] && scrollTop>tiGan[i-1]){
                        allEle[i-1].style.position='fixed';
                        allEle[i-1].style.top=0;
                        allEle[i-1].style.zIndex=2;
                        allEle[i-1].style.background='#ffffff';
                        allEle[i-1].style.width=allEle[i].parentNode.offsetWidth+'px';
                        allEle[i].style='';
                    }else if(scrollTop<tiGan[0]){
                        allEle[0].style='';
                    }
                }
                
                
            },
            beforeunloadHandler(e) {
                e = e || window.event;
                if (e) {
                    e.returnValue = '关闭后，做题记录将被清空';
                }
                return '关闭后，做题记录将被清空';
            },
            strcharacterDiscode
        },
        created() {
            this.$changeTitle(this.$route.query.testpaper_name+'--');
            this.testpaper_name=this.$route.query.testpaper_name;
            
            
            
            this.getdata()
            this.getCategory()
            this.getConfigure()
            store.commit('setNav',null);
        },
        mounted() {
            
            // handleScroll为页面滚动的监听回调
            window.addEventListener('scroll', this.handleScroll);

            window.addEventListener("beforeunload", e => {
                this.beforeunloadHandler(e);
            });

        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);

            window.removeEventListener("beforeunload", e => {
                this.beforeunloadHandler(e);
            });

            clearInterval(this.timeId)

            var data = {},do_time,obj ={};
                this.topic_data.forEach((item,i)=>{
                    if (item.userAnswer !== '') {
                        data[item.id] = item.userAnswer
                    }
                })
                
                if(this.startSecond!='' && this.allTime>Number(this.startSecond)){
					do_time=Number(this.startSecond)
				}else{
					do_time=this.allTime
				}
                obj.paper_id=this.all_data.testpaper_id
                obj.total_time=do_time
                obj.data=data
            if(this.isUpdata){
                var local=localStorage.getItem("tpTimeData") ? JSON.parse(localStorage.getItem("tpTimeData")): null;
                if(local&&local.testpaper_id==this.all_data.testpaper_id){
                    local.allTime=this.allTime
                    localStorage.setItem("tpTimeData", JSON.stringify(local));
                }
                this.updatePaper(obj)

            }

            if(this.topic_data&&this.topic_data.length){
                this.endTime=Date.parse(new Date())
				var array=[]
				var array2=[]
				array[0]=this.startTime/1000
				array[1]=this.endTime/1000
				array2.push(array)
				var obj={
					study_duration_type: 2,
					study_time: array2
                }
                this.incrUserStudyTime(obj)
            }
            
        }
    }
</script>

<style scoped>
    body,#app{
        height: none;
    }
    .paper_title_box{
        width: 100%;
        height: 60px;
        background: #ffffff;
    }
    .paper_title{
        margin: 0 auto;
        width: 1200px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 18px;
        color: #333333;
    }
    .container_warp{
        width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        display: flex;
    }
    .paper_left{
        width: 270px;
        margin-right: 20px;
    }
    .submit_btn{
        width: 140px;
        height: 40px;
        background: #00C590;
        border-radius: 20px;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .time_box{
        width: 270px;
        height: 180px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .t_down{
        margin: 16px 0;
        font-size: 24px;
        color: #000000;
    }
    .card_box{
        margin-top: 20px;
        width: 270px;
        min-height: 540px; 
        background: #ffffff;
    }
    .card_title_box{
        background: #EDEDED;
        height: 50px;
        width: 100%;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
    }
    .mark_wrap{
        width: 100%;
        height: 60px;
        padding: 0 20px;
        box-sizing: border-box;
    }
    .mark_box{
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 34px;
        border-bottom: 1px solid #e7e7e7;
        box-sizing: border-box;
    }
    .mark_item{
        display: flex;
        align-items: center;
        font-size: 16px;
    }
    .mark_dot{
        width: 20px;
        height: 20px;
        background: #00C590;
        border-radius: 50%;
        margin-right: 10px;
    }
    .mark_dot_white{
        background: #ffffff;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
    }
    .card_opt{
        /* padding: 0 20px; */
        padding-bottom: 20px;
        font-size: 0;
    }
    .card_opt_title{
        font-size: 16px;
        color: #333333;
        margin-top: 20px;
        margin-left: 20px;
    }
    .card-btn-box{
        margin-top: 20px ;
        margin-left: 20px;
        display: inline-block;
    }
    .card_active{
        color: #ffffff !important;
        background: #00C590;
        border: none !important;
    }
    .cu-btn{
        width: 30px;
        height: 30px;
        border: 1px solid #CCCCCC;
        border-radius: 50%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #999999;
    }
    .paper_right{
        width: 910px;
    }
    .topic_main{
        background: #ffffff;
    }
    .tpc_top{
        margin-top: 20px;
    }
    .topic_title_box{
        width: 910px;
        box-sizing: border-box;
        /* height: 40px;
        line-height: 40px; */
        min-height: 40px;
        display: flex;
        align-items: center;
        padding: 8px 0;
        font-size: 18px;
        padding-left: 20px;
        background: #EDEDED;
    }
    .topic_wrap_pl{
        padding: 0 20px;
    }
    .material_box{
        width: 870px;
        height: 250px;
        border: 1px solid #CCCCCC;
        border-radius: 5px;
        box-sizing: border-box;
        overflow: auto;
    }
    .material_box::-webkit-scrollbar{
        width: 10px;
    }
    .material_box::-webkit-scrollbar-thumb{
        border-radius: 5px;
        background: #BBBBBB;
    }
    .material_box::-webkit-scrollbar-track{
        border-radius: 5px;
        background: #E7E7E7;
    }
    .topic_num_topline{
        border-top: 1px solid #E7E7E7;
    }
    .topic_num_btmline {
        border-bottom: 1px solid #E7E7E7;
    }
    .topic_num_box{
        /* height: 54px; */
        padding-top: 20px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .tnb_left{
        display: flex;
        align-items: center;
    }
    .tn_dot{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #00C590;
        margin-right: 10px;
        position: relative;
    }
    .tn_dot:before{
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ffffff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .tnb_right{
        display: flex;
        align-items: center;
    }
    .tnb_right_w{
        margin-right: 20px;
        display: flex;
        align-items: center;
    }
    .tnb_right_s{
        display: flex;
        align-items: center;
    }
    .fk_img{
        width: 18px;
        height: 18px;
        margin-right: 6px;
    }
    .look_img{
        width: 17px;
        height: 19px;
        margin-right: 6px;
    }
    .no_tpc{
        padding: 10px 0 30px;
        width: 100%;
        text-align: center;
        color: #999999;
    }
    .area_warp{
        width: 100%;
        height: 250px;
        border: 1px solid #CCCCCC;
        border-radius: 5px;
        box-sizing: border-box;
        padding-top: 20px;
        padding-left: 20px;
    }
    .area_txt{
        box-sizing: border-box;
        width: 100%;
        height: 180px;
        border: none;
        outline: none;
        resize: none;
        background: #ffffff;
    }
    textarea::-webkit-scrollbar{
        width: 10px;
    }
    textarea::-webkit-scrollbar-thumb{
        border-radius: 5px;
        background: #BBBBBB;
    }
    textarea::-webkit-scrollbar-track{
        border-radius: 5px;
        background: #E7E7E7;
    }
    
    .area_num{
        display: flex;
        justify-content: space-between;
        color: #999999;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        padding: 0 30px;
    }
    .score_box{
        margin-top: 20px;
        display: flex;
        box-sizing: border-box;
    }
    .score_ipt_box{
        width: 100%;
        height: 50px;
        border: 1px solid #CCCCCC;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        align-items: center;
    }
    .score_txt{
        font-size: 16px;
        font-family: Microsoft YaHei;
        color: #00C590;
    }
    .score_ipt{
        width: 100%;
        border: none;
        outline: none;
        background: #ffffff;
    }
    input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{
        -webkit-appearance: none !important; 
    }
    .score_btn_wrap{
        margin-left: 30px;
    }
    .score_btn{
        width: 140px;
        height: 50px;
        background: #00C590;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }
    .opt5{
        opacity: .5;
    }
    .score_hit{
        margin-top: 10px;
        text-align: left;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    .opt_group_box{
        padding-bottom: 10px;
    }
    .radio_opt_wrap{
        margin-top: 20px;
        padding-left: 30px;
        padding-top: 6px;
        padding-bottom: 6px;
        position: relative;
    }
    .radio_opt_wrap:hover{
        background: #e7e7e7;
    }
    .radio_opt_box{
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        border: 1px solid #CCCCCC;
        border-radius: 50%;
        box-sizing: border-box;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        color: #999999;
    }
    .opt_active{
        color: #ffffff;
        background: #00C590;
        border: 1px solid #00C590;
    }
    .el-card{
        border: none;
    }
    .el-main {
        color: #333;
    }
    /* .card_head{
        padding: 18px 20px;
        //border-bottom: 1px solid #EBEEF5;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    .card_conter{
        padding: 18px 0 18px 20px;
    } */
    /* .card_btm{
        margin-top: 10px;
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
    } */
    /* .t_title{
        padding-bottom: 10px;
    } */
    /* .title_analy{
        border-top: 1px solid #ddd;
        padding-top: 20px;
    } */
    .main_left{
        background: #fff; 
    }
    /* .material_box{
        border: 1px solid #ddd;
        padding: 5px 15px 5px 20px;
        margin-bottom: 40px;
        border-radius: 4px;
    } */
    /* .cardOption a{
        position: relative;
        display: inline-block;
        border-radius: 4px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #616161;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        border: 1px solid #e1e1e1;
    } */
    .active{
        background: #699975 !important;
        color: #fff !important;
    }
    .card_box{
        /* position: fixed; */
    }
    /* .right-sc{
        float: right;
        padding: 10px;
        margin-bottom: 10px
    }
    .right-sc div{
        float: left;
        font-size: 14px;
        color: #666;
        line-height: 30px;
        padding-left: 19px;
        margin-right: 20px;
        cursor: pointer;
    } */
    .checkbox{
        padding: 9px 10px 9px 10px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        line-height: normal;
        height: 40px;
        display: inline-block;
    }
    .activecheck{
        background: #699975;
        color: #fff;
        border-color: #699975 !important;
    }
    .bj{
        background: url(../assets/bj1.png) no-repeat left center;
    }
    .activebj{
        background: url(../assets/bj2.png) no-repeat left center;
    }
    .card_bj{
        /* display: none; */
        background: url(../assets/bj3.png) no-repeat 0px 0px;
        position: absolute;
        left: -1px;
        top: -1px;
        width: 25px;
        height: 25px;
    }
    .subit{
        margin: 0 auto;
        line-height: 40px;
        background: #47c88a;
        color: #fff;
        font-size: 16px;
        border-radius: 6px;
        text-align: center;
        max-width: 240px;
    }
    .padding-top{
        padding-top: 10px;
    }
    /* .main_left {
        margin-right: 10px;
    } */
    /* .margin_btm{
        margin-bottom: 10px;
    } */
    .material_box >>> img{
        max-width: 100%;
    }
    .txt_vh >>> img{
        max-width: 100%;
    }
    .txt_vh >>> p{
        margin: 0;
    }
    
    .popup >>> .el-dialog{
        width: 600px;
        height: 520px;
        overflow: auto;
        border-radius: 20px;
    }
    .popup >>> .el-dialog::-webkit-scrollbar{
        display: none;
    }
    .popup >>> .el-dialog__title{
        font-size: 22px;
        color: #333333;
        font-weight: 900;
    }
    .popup >>> .el-dialog__headerbtn .el-dialog__close{
        font-size: 28px;
    }
    .wrong_pop_title{
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 900;
    }
    .w_mt{
        margin-top: 30px;
    }
    .worng_nav_wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .textarea_wrap textarea{
        resize: none;
        border: none;
        width: 100%;
        height: 100%;
        outline:none;
        background: #ffffff;
    }
    .worng_nav{
        margin-right: 20px;
        margin-top: 20px;
    }
    .worng_nav_sub{
        border: 1px solid #DDDDDD;
        border-radius: 5px;
        padding: 12px 10px;
    }
    .popw_active{
        border: 1px solid #00C590;
        color: #00C590;
    }
    .textarea_wrap{
        margin-top: 20px;
        /* width: 540px; */
        width: 100%;
        height: 120px;
        background: #FFFFFF;
        border: 1px solid #DDDDDD;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
    }
    .wrong_pop_btn{
        margin: 30px auto 0;
        width: 300px;
        height: 50px;
        background: #00C590;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: #ffffff;
    }

    .shade{
        width: 100%;
        height: 100%;
        background: rgba(122,122,122, .5);
        position: fixed;
        left: 0;
        top: 0;
    }
    .pop_submit{
        width: 400px;
        height: 280px;
        background: #FFFFFF;
        border-radius: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .code_pop_box{
        width: 420px;
        height: 420px;
    }
    .pop_submit_title{
        color: #333333;
        font-size: 20px;
        text-align: center;
        padding-top: 80px;
    }
    .pop_code_title{
        padding-top: 30px;
        text-align: center;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    .code_icon{
        width: 300px;
        height: 300px;
        margin: 30px auto 0;
    }
    .pop_submit_btn{
        margin-top: 60px;
        width: 200px;
        height: 50px;
        background: #00C590;
        font-size: 22px;
        color: #FFFFFF;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .pop_i_close{
        font-size: 28px;
        color: #999999;
        position: absolute;
        top: 20px;
        right: 20px;
    }
    .pop_code_close{
        font-size: 28px;
        color: #999999;
        position: absolute;
        top: 30px;
        right: 20px;
    }
    .pop_btm_btn{
        display: flex;
        justify-content: space-between;
        padding: 0 45px;
        margin-top: 60px;
        width: 100%;
        box-sizing: border-box;
    }
    .p_left_btn,
    .p_right_btn{
        width: 140px;
        height: 50px;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
    }
    .p_left_btn{
        background: #00C590;
        color: #fff;
    }
    .p_right_btn{
        color: #00C590;
        border: 1px solid #00C590;
        box-sizing: border-box;
    }
    .scllotop_img{
        width: 31px;
        height: 31px;
        position: fixed;
        bottom: 100px;
        right: 320px;
    }
    .red{
        color: red;
    }
    .ogrey{
        opacity: .3;
    }
    .footer_block{
        width: 100%;
        height: 30px;
    }
    .only_r{
		color: #00C590;
		border:1px solid #00C590;
	}
    .r_active{
        background: #00C590;
        color: #ffffff;
        border: none;
    }
    .w_active{
        background: #FF4C4C;
        color: #ffffff;
        border: none;
    }

    .anwer_box{
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
    .anwer_box_left,.anwer_box_right{
        font-size: 16px;
        font-weight: bold;
    }
    .anwer_box_left{
        display: flex;
        align-items: center;
    }
    .statu_img{
        width: 21px; 
        height: 21px;
        margin-right: 9px;
    }
    .anwer_box_right{
        margin-left: 30px;
        color: #333333;
    }
    .j_anwer_box{
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin-top: 20px;
    }
    .j_anwer_content{
        font-weight: 400;
    }
    .j_anwer_content_pt{
        margin-top: 20px;
    }
    .analy_btm_padd{
        padding-bottom: 30px;
    }
    .r_txt{
        color: #00C590;
    }
    .w_txt{
        color: #FF4C4C;
    }
    .n_txt{
        color: #59AAFF;
    }
    .myAnwer_box{
        margin-top: 20px;
    }
    .myAnwer_txt{
        font-size: 16px;
        font-family: Microsoft YaHei;
        color: #333333;
        margin-top: 10px;
    }
</style>
<style>
    #app{
        min-width: 960px;
    }
</style>



// WEBPACK FOOTER //
// src/page/LookTopic.vue